export default [
    {
        path: 'relatorio-documento-nao-assinado',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-relatorio-documento-nao-assinado' */
            '@/views/pronto-atendimento/relatorio-documento-nao-assinado/Index'
        ),
        redirect: 'relatorio-documento-nao-assinado/index',
        children: [
            {
                name: 'pronto-atendimento-relatorio-documento-nao-assinado-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-relatorio-documento-nao-assinado' */
                    '@/views/pronto-atendimento/relatorio-documento-nao-assinado/List'
                ),
            },
        ]
    }
]